// MARK: React
import * as React from "react";
import { observer, inject } from "mobx-react";
import "./style.scss";

// MARK: Components
import GallerysTable from "./GallerysTable";
import GalleryCreateOrEdit from "./GalleryCreateOrEdit";

// MARK: Router
import { Route, Switch } from "react-router-dom";

// MARK: Stores
import AuthStore from "../../../stores/AuthStore";

interface IProps {
	authStore: AuthStore;
}

@inject("authStore")
@observer
export default class Gallery extends React.Component<IProps> {
	public componentDidMount = async () => {
		await this.props.authStore.authenticate();
	};

	public render() {
		return (
			<div className="gallerys">
				<Switch>
					<Route exact={true} path="/dashboard/gallery/editor" component={GalleryCreateOrEdit} />
					<Route path="/dashboard/gallery/editor/:galleryId" component={GalleryCreateOrEdit} />
					<Route path="/dashboard/gallery" component={GallerysTable} />
				</Switch>
			</div>
		);
	}
}
